import type { TextareaHTMLAttributes } from 'react';

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
};

export function Textarea({ label, ...rest }: Props) {
  return (
    <div className="flex flex-column">
      <small>
        <label
          htmlFor={rest.id}
          className="form-label text-muted text-capitalize"
        >
          {label}
        </label>
      </small>
      <textarea
        className="form-control"
        rows={4}
        minLength={3}
        maxLength={1000}
        {...rest}
      />
    </div>
  );
}
